var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, Card, CardActionArea, CardContent, CardMedia, IconButton, Typography } from "@mui/material";
import MapIcon from '@mui/icons-material/Map';
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import ZoomInIcon from '@mui/icons-material/ZoomIn';
var ManifestCard = function (_a) {
    var manifest = _a.manifest, onSelect = _a.onSelect, isSelected = _a.isSelected, onShowInViewer = _a.onShowInViewer;
    var cardMedia = function () { return _jsx(CardMedia, { component: "img", image: manifest === null || manifest === void 0 ? void 0 : manifest.thumb(300), alt: manifest.label(), height: 170 }, manifest.uri); };
    var actionArea = function () {
        if (onSelect && manifest.navPlace() !== null) {
            return (_jsx(CardActionArea, __assign({ onClick: function () { return onSelect ? onSelect(manifest) : null; } }, { children: cardMedia() }), void 0));
        }
        else {
            return cardMedia();
        }
    };
    return (_jsxs(Card, __assign({ raised: true }, { children: [actionArea(), _jsxs(CardContent, { children: [_jsx(Typography, __assign({ variant: "caption", component: "h2", display: "-webkit-box", overflow: "hidden", height: 60, sx: { "WebkitLineClamp": 3 } }, { children: manifest.label() }), void 0), _jsx(Box, __assign({ sx: { clear: "both" } }, { children: (manifest.navDateYear()) ?
                            _jsxs("div", { children: [_jsx(CalendarMonthIcon, { sx: { float: "left" } }, void 0), _jsx(Typography, __assign({ variant: "caption", display: "inline", gutterBottom: true }, { children: manifest.navDateYear() }), void 0)] }, void 0)
                            :
                                _jsx("div", { children: _jsx(CalendarMonthIcon, { color: "disabled", sx: { float: "left", opacity: '50%' } }, void 0) }, void 0) }), void 0), _jsxs(Box, __assign({ sx: { clear: "left" } }, { children: [(manifest.navPlace()) ? _jsx(MapIcon, { color: isSelected ? "primary" : "inherit" }, void 0) :
                                _jsx(MapIcon, { color: "disabled", sx: { opacity: '50%' } }, void 0), _jsx(IconButton, __assign({ sx: { float: "right" }, size: "small", onClick: function () { return onShowInViewer ? onShowInViewer(manifest) : null; } }, { children: _jsx(ZoomInIcon, {}, void 0) }), void 0)] }), void 0)] }, void 0)] }), void 0));
};
export default ManifestCard;
